var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiveChatFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#live-chat-fb_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5.001A6.375 6.375 0 000 6.23a6.11 6.11 0 002.167 4.636v1.863a.27.27 0 00.415.23l1.51-.943c.768.294 1.585.444 2.408.442A6.375 6.375 0 0013 6.23 6.375 6.375 0 006.5 0z",
    fill: "#7BB6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.779 4.442a.27.27 0 00-.347-.075L7.616 5.902 5.863 4.4a.27.27 0 00-.367.014l-3.25 3.25a.27.27 0 00.321.428l2.817-1.535L7.137 8.06a.27.27 0 00.368-.014l3.25-3.25a.27.27 0 00.024-.354z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "live-chat-fb_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13v13H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/live-chat-fb.27ac349792447ef394df77b3631de6ad.svg";
export { SvgLiveChatFb as ReactComponent };